<template>
  <div>
    <div class="row reading-form-container">
      <div class="small-12 columns">
        <button class="button-green" @click="addInterviewQuestion">
          Add Interview Question
        </button>
      </div>
      <div class="small-3 columns">Name</div>
      <div class="small-9 columns">
        <input v-model="name" type="text" class="input-box-course-creators" />
      </div>
      <div class="small-3 columns">Time Allocated (sec)</div>
      <div class="small-9 columns">
        <input
          v-model="timeAllocated"
          type="number"
          step="1"
          class="input-box-course-creators"
        />
      </div>
      <div class="small-3 columns">Buffer Time (sec)</div>
      <div class="small-9 columns">
        <input
          v-model="readingTime"
          type="number"
          step="1"
          class="input-box-course-creators"
        />
      </div>
      <div class="row">
        <div class="small-8 columns">
          <simplemde
            v-model="content"
            uniqueId="edyst-interview-question-content"
          ></simplemde>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import simplemde from "@/components/simpleMarkdownEditor/SimpleMarkdown"

export default {
  components: { simplemde },
  data() {
    return {
      name: "",
      type: 7,
      readingTime: 0,
      timeAllocated: 0,
      content: "",
    }
  },
  methods: {
    addInterviewQuestion() {
      const payload = {
        type: this.type,
        name: this.name,
        reading_time: this.readingTime,
        time_allocated: this.timeAllocated,
        content: this.content,
      }
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}questions/`,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.$router.push("/interview")
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
